import { createApiCall } from 'lib/base';

interface ChangeAccountPasswordBody {
  old_password: string;
  new_password: string;
}

const CHANGE_ACCOUNT_PASSWORD = 'CHANGE_ACCOUNT_PASSWORD';

export const changeAccountPasswordApi = createApiCall<
  ChangeAccountPasswordBody
>(CHANGE_ACCOUNT_PASSWORD, body => ({
  endpoint: `api/admin/account/change-password`,
  method: 'POST',
  body: JSON.stringify(body),
  // the page shows its own message (e.g. wrong current password)
  skipDefaultErrorMessage: true,
}));

export default changeAccountPasswordApi;
